module.exports = __webpack_public_path__ + "static/media/music.f2b50b0f.png";